import { Feedback } from './Feedback';
export class CheckForSuccess {
  constructor(successMessage, pattern) {
    this.successMessage = successMessage;
    this.pattern = pattern;
  }
  feedbackForAnswer(answer) {
    if (answer.compare(this.pattern)) {
      return new Feedback(true, this.successMessage);
    }
    return null;
  }
}